import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Empty,
  Form,
  Image,
  Modal,
  Radio,
  Tag,
  Tooltip,
} from 'antd';
import { debounce, filter, find, forEach, isEmpty, map } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import useInventoryUnitsFeature from '../../../../../hooks/useInventoryUnitsFeature';
import MappedUnitsCell from '../../../../../components/MappedUnitsCell';
import { AppContext } from '../../../../../AppContext';
import { ReactComponent as PlayIcon } from '../../../../../assets/svg/play-solid.svg';
import { ReactComponent as CommentIcon } from '../../../../../assets/svg/comment-dots-solid.svg';
import { ReactComponent as FilterIcon } from '../../../../../assets/svg/sliders-solid.svg';
import { ReactComponent as DislikeRatingIcon } from '../../../../../assets/svg/thumbs-down-solid.svg';
import { ReactComponent as LikeRatingIcon } from '../../../../../assets/svg/thumbs-up-solid.svg';
import ModalComponent from '../../../../../components/ModalComponent';
import {
  DATE_FORMATS,
  DELIVERY_TYPE,
  DELIVERY_TYPE_OPTIONS,
  LIMIT,
  ORDER_STATUS,
  PRODUCT_RATE,
  REQUEST_TYPES,
  RETURN_ORDER_ITEM_STATUS,
  RETURN_RIDER_REASSIGNABLE_STATUSES,
  RETURN_ORDER_TABLE_ACTIONS_OPTIONS,
  SORT,
  USER_ROLES,
} from '../../../../../common/constants';
import {
  fileUpload,
  formatDate,
  getAttachmentSource,
  hasLargeToy,
  hasNonEmptyValueObj,
  openNotification,
} from '../../../../../common/utils';
import CommonPreview from '../../../../../components/CommonPreview';
import CommonPreviewTable from '../../../../../components/CommonPreviewTable';
import CommonTable from '../../../../../components/CommonTable';
import FulfilmentPossibilityDrawer from '../../../../../components/FulfilmentPossibilityDrawer';
import LoaderComponent from '../../../../../components/LoaderComponent';
import OrderDynamicTags from '../../../../../components/OrderDynamicTags';
import SearchComponent from '../../../../../components/SearchComponent';
import SkipChecklistAction, {
  getSkipChecklistValue,
} from '../../../../../components/ReturnOrders/SkipChecklistAction';
import SelectComponent from '../../../../../components/SelectComponent';
import useInfiniteScroll from '../../../../../hooks/useInfiniteScroll';
import ContentMasterModal from '../../../../../modules/orders/modules/all/components/ContentMasterModal';
import ToyVideoModal from '../../../../raiseRequest/components/ToyVideoModal';
import { LIBRARIES } from '../../../../raiseRequest/graphql/Queries';
import { PINCODES } from '../graphql/Queries';
import {
  CONFIRM_RETURN_ORDER,
  CREATE_REQUEST_LIBRARY,
  UPDATE_RETURN_ORDER,
} from '../../all/graphql/Mutations';
import NoteModal from './NoteModal'
import AllFilterReturnOrderModal from '../../all/components/AllFilterReturnOrderModal';
import OrderTagsFilter from '../../../../../components/OrderTagsFilter';
import AllReturnOrderItemModal from '../../all/components/AllReturnOrderItemModal';
import AllReturnOrderList from '../../all/components/AllReturnOrderList';
import ReportDamageModal from '../../all/components/ReportDamageModal';
import { GET_LIBRARY_DAMAGE_REQUEST_IMAGE_SINGED_PUT_URL, GET_LIBRARY_REQUEST_TOY_VIDEO_SIGNED_PUT_URL, RETURN_ORDERS, RETURN_ORDERS_SELECT } from '../../all/graphql/Queries';
import BigToyIcon from '../../../../../modules/orders/modules/new/components/BigToyIcon';
import UserSelect from '../../../../../modules/payments/modules/endUser/components/UserSelect';
import { ASSIGN_DELIVERY_PARTNER_TO_RETURN_ORDER } from '../graphql/Mutations';
import AssignDeliveryPartnerModal from '../../../../../modules/orders/modules/new/components/AssignDeliveryPartnerModal'
import RenderCopyIcon from '../../../../../components/RenderCopyIcon';

const { RangePicker } = DatePicker;
const { Group } = Radio;

const initialPaginationValue = {
  total: 0,
  current: 1,
  pageSize: 10,
};

const initialOrderFilter = {
  limit: LIMIT,
  search: '',
  skip: 0,
  status: RETURN_RIDER_REASSIGNABLE_STATUSES,
  showReturnRequestedOrderCount: true,
};

const initialOrderSort = {
  field: 'createdAt',
  order: 'DESC',
};

const initialTableFilter = {
  skip: 0,
  limit: LIMIT,
  search: '',
};

const initialTableSort = {
  field: 'createdAt',
  order: 'DESC',
};

let filterScrollDebounceJob = null;

const AllReturnTable = ({ exportFilter, setExportFilter ,isAssignDelPartnerTab}) => {
  const {
    dispatch,
    state: { isDesktop, currentUser, orderCount },
    getCurrentUser,
  } = useContext(AppContext);
  const [assignDelPartnerForm] = Form.useForm();
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const returnId = queryParams?.get('returnId') || '';
  const status = queryParams?.get('status') || '';
  const [reportDamageForm] = Form.useForm();
  const { roles } = getCurrentUser() || {};
  const { isUnitsFeatureEnabled } = useInventoryUnitsFeature();

  const [orderList, setOrderList] = useState([]);
  const [possibilityDrawerVisible, setPossibilityDrawerVisible] =
    useState(false);
  const [selectedPossibilityItem, setSelectedPossibilityItem] = useState(null);
  const [orderSearchTerm, setOrderSearchTerm] = useState('');
  const [isEmptyOrderList, setIsEmptyOrderList] = useState(false);
  const [order, setOrder] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [paginationProp, setPaginationProp] = useState(initialPaginationValue);
  const [deliveryPartnerData, setDeliveryPartnerData] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isOrderLoading, setIsOrderLoading] = useState(true);
  const [isNotePrompts, setIsNotePrompts] = useState(false);
  const [isReportDamageModalOpen, setIsReportDamageModalOpen] = useState(false);
  const [isReportDamageLoading, setIsReportDamageLoading] = useState(false);
  const [isConfirmReturnLoading, setIsConfirmReturnLoading] = useState(false);
  const [isConfirmReturnPrompts, setIsConfirmReturnPrompts] = useState(false);
  const [visible, setVisible] = useState(false);
  const [toyImages, setToyImages] = useState([]);
  const [damageToyImage, setDamageToyImage] = useState([]);
  const [toyVideo, setToyVideo] = useState([]);
  const [toyPreviewImage, setToyPreviewImage] = useState();
  const [toyPreviewVideo, setToyPreviewVideo] = useState();
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [orderItem, setOrderItem] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [isNotPickedUpReasonModalOpen, setIsNotPickedUpReasonModalOpen] =
    useState(false);
  const [notPickedUpReason, setNotPickedUpReason] = useState('');
  const [notPickedUpRiderName, setNotPickedUpRiderName] = useState('');
  const [isReturnPrompts, setIsReturnPrompts] = useState(false);
  const [isReturnOrderLoading, setIsReturnOrderLoading] = useState(false);
 const [isDeliveryPartnerPrompts, setIsDeliveryPartnerPrompts] = useState(
    false,
  );
   const [isDeliveryPartnerLoading, setIsDeliveryPartnerLoading] = useState(
    false,
  );
   const [isDeliveryPartnerModalOpen, setDeliveryPartnerModalOpen] = useState(
    false,
  );
  const [filterSearch, setFilterSearch] = useState('');
  const [filterList, setFilterList] = useState([]);
  const [whereFilter, setWhereFilter] = useState();
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterTags, setFilterTags] = useState(null);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterIndex, setFilterIndex] = useState(null);
  const [finalWhereFilters, setFinalWhereFilters] = useState();
  const [finalFilterTags, setFinalFilterTags] = useState(null);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const selectedTagIdsRef = useRef([]);
  const [filterIsEnd, setFilterIsEnd] = useState(false);
  const [isEmptyFilterList, setIsEmptyFilterList] = useState(false);

  const [isAllFilterModalOpen, setIsAllFilterModalOpen] = useState(false);
  const [isFetchMoreOrderLoading, setIsFetchMoreOrderLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [
    isAllReturnOrderItemModalOpen,
    setIsAllReturnOrderItemModalOpen,
  ] = useState(false);
  const [isContentMasterModalOpen, setIsContentMasterModalOpen] = useState(
    false,
  );

  const [getLibraryRequestToyVideoSignedPutUrl] = useLazyQuery(
    GET_LIBRARY_REQUEST_TOY_VIDEO_SIGNED_PUT_URL,
    {
      fetchPolicy: 'network-only',
      onError() {
        setIsReportDamageLoading(false);
      },
    },
  );

  const [returnOrders] = useLazyQuery(RETURN_ORDERS, {
    onCompleted: (response) => {
      dispatch({
        type: 'SET_ORDER_COUNT',
        data: {
          ...orderCount,
          returnOrderCount: response?.returnOrders?.count,
          returnRequestedOrderCount:
            response?.returnOrders?.returnRequestedOrderCount,
        },
      });
      if (isDesktop) {
        setOrderList([...response?.returnOrders?.data]);
      } else {
        setOrderList([...orderList, ...response?.returnOrders?.data]);
      }
      if (
        response?.returnOrders?.count === 0 &&
        initialPaginationValue?.total === 0
      ) {
        setIsEmptyOrderList(true);
      } else {
        setIsEmptyOrderList(false);
      }
      if (response?.returnOrders?.data?.length < LIMIT) {
        setIsActive(false);
      }
      const pagination = {
        ...paginationProp,
        defaultPageSize: LIMIT,
        total: response?.returnOrders?.count,
      };
      setPaginationProp(pagination);
      setIsOrderLoading(false);
      setIsFetchMoreOrderLoading(false);
    },
    fetchPolicy: 'no-cache',
    onError() { },
  });

  const [pincodes, { loading: isPincodesLoading }] = useLazyQuery(PINCODES, {
    onCompleted: (response) => {
      if (response?.pincodes?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.pincodes?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.pincodes?.data, (item) =>
        optionsCopy?.push({
          label: item?.pincode,
          key: item?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [libraries] = useLazyQuery(LIBRARIES, {
    onCompleted: (response) => {
      if (response?.libraries?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.libraries?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.libraries?.data, (item) =>
        optionsCopy?.push({ label: item?.name, key: item?.id }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [
    returnOrdersSelect,
    { loading: isReturnOrdersSelectLoading },
  ] = useLazyQuery(RETURN_ORDERS_SELECT, {
    onCompleted: (response) => {
      if (response?.returnOrders?.data?.length < LIMIT) {
        setFilterIsEnd(true);
      }
      if (response?.returnOrders?.count === 0) {
        setIsEmptyFilterList(true);
      } else {
        setIsEmptyFilterList(false);
      }
      const optionsCopy = [];
      forEach(response?.returnOrders?.data, (item) =>
        optionsCopy?.push({
          label: item?.returnOrder?.returnOrderNumber,
          key: item?.returnOrder?.id,
        }),
      );
      setFilterList([...filterList, ...optionsCopy]);
      setFilterLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {
      setFilterLoading(false);
    },
  });

  const [createRequestLibrary] = useMutation(CREATE_REQUEST_LIBRARY, {
    onError: () => { },
  });

  const [confirmReturnOrder] = useMutation(CONFIRM_RETURN_ORDER, {
    onError: () => { },
  });
  const [updateOrderStatus] = useMutation(UPDATE_RETURN_ORDER, {
    onError: () => { },
  });

  const [getSignUrl] = useLazyQuery(
    GET_LIBRARY_DAMAGE_REQUEST_IMAGE_SINGED_PUT_URL,
    {
      fetchPolicy: 'network-only',
      onError() { },
    },
  );

  useEffect(() => {
    setOrderSearchTerm(returnId || orderSearchTerm);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    setIsOrderLoading(true);
    setOrderList([]);
    let finalStatus;
    const { label, value } =
      find(map(RETURN_ORDER_ITEM_STATUS), {
        value: status,
      }) || {};
    if (value) {
      const filterValue = { status: [value] };
      const filterTagValue = { status: [{ label, key: value }] };
      finalStatus = [value];
      setFinalWhereFilters(filterValue);
      setWhereFilter(filterValue);
      setFilterTags(filterTagValue);
      setFinalFilterTags(filterTagValue);
    } else if (finalWhereFilters?.status?.length > 0) {
      finalStatus = finalWhereFilters.status;
    }
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: returnId || orderSearchTerm,
          limit: paginationProp?.pageSize || LIMIT,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status: finalWhereFilters?.status?.length > 0
            ? finalWhereFilters?.status
            : initialOrderFilter?.status,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          pincodeIds: finalWhereFilters?.pincodes,
          ownerLibraryIds:
            finalWhereFilters?.ownerLibraryName?.length > 0
              ? finalWhereFilters?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            finalWhereFilters?.receivingLibraryName?.length > 0
              ? finalWhereFilters?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sortedInfo?.column
          ? {
            field: sortedInfo?.field,
            order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
  }, [isDesktop, status]);

  const handleTableChange = (pagination, tableFilter, sorter) => {
    const { current } = pagination;
    const skip = (current - 1) * (pagination?.pageSize || 0);
    setPaginationProp({ ...paginationProp, ...pagination });
    setIsOrderLoading(true);
    setSortedInfo(sorter);
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          skip,
          limit: pagination?.pageSize,
          search: orderSearchTerm,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : initialOrderFilter?.status,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          pincodeIds: finalWhereFilters?.pincodes,
          ownerLibraryIds:
            finalWhereFilters?.ownerLibraryName?.length > 0
              ? finalWhereFilters?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            finalWhereFilters?.receivingLibraryName?.length > 0
              ? finalWhereFilters?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sorter?.column
          ? {
            field: sorter?.field,
            order: sorter?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
  };

  const handleSearch = (value) => {
    const trimValue = value?.trim();
    setOrderSearchTerm(trimValue);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    setOrderList([]);
    setIsOrderLoading(true);
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: trimValue,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status:
            finalWhereFilters?.status?.length > 0
              ? finalWhereFilters?.status
              : initialOrderFilter?.status,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          pincodeIds: finalWhereFilters?.pincodes,
          ownerLibraryIds:
            finalWhereFilters?.ownerLibraryName?.length > 0
              ? finalWhereFilters?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            finalWhereFilters?.receivingLibraryName?.length > 0
              ? finalWhereFilters?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sortedInfo?.column
          ? {
            field: sortedInfo?.field,
            order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
    setExportFilter({ ...exportFilter, search: trimValue });
  };

  const handleReportDamage = async (values) => {
    setIsReportDamageLoading(true);
    const uuid = uuidv4();
    let damageToyFileName = [];
    let video = '';
    if (values?.video?.length > 0) {
      const { name } = values?.video?.[0];
      const ext = name?.substring(name?.lastIndexOf('.') + 1);
      const timestamp = Date?.now();
      const filename = name?.split('.')?.slice(0, -1)?.join('.');
      const newFilename = `${timestamp}_${filename}.${ext}`;
      const fileKey = `toy/${uuid}/${newFilename}`;

      const res = await getLibraryRequestToyVideoSignedPutUrl({
        variables: {
          data: {
            fileName: fileKey,
            type: REQUEST_TYPES?.LIBRARY_DAMAGE,
          },
        },
      });
      if (res?.data) {
        try {
          try {
            await fileUpload(
              res?.data?.getLibraryRequestToyVideoSignedPutUrl?.signedUrl,
              toyVideo?.[0]?.originFileObj,
            );
            video = res?.data?.getLibraryRequestToyVideoSignedPutUrl?.fileName;
          } catch (error) {
            throw new Error(
              `${toyVideo?.name} upload failed. Please try again.`,
            );
          }
        } catch (error) {
          setIsReportDamageLoading(false);
          openNotification('error', error.message);
        }
      }
    }
    if (!values?.damageToyImage?.url && values?.damageToyImage?.length > 0) {
      const toyImageArray = values?.damageToyImage?.map((item) => {
        const { name } = item;
        const ext = name?.substring(name?.lastIndexOf('.') + 1);
        const timestamp = Date?.now();
        const filename = name?.split('.')?.slice(0, -1)?.join('.');
        const newFilename = `${timestamp}_${filename}.${ext}`;
        const fileKey = `toy/${uuid}/${newFilename}`;

        return fileKey;
      });

      const res = await getSignUrl({
        variables: {
          data: {
            fileNames: toyImageArray,
            type: REQUEST_TYPES?.LIBRARY_DAMAGE,
          },
        },
      });

      if (res?.data) {
        try {
          const response = await Promise.all(
            res?.data?.getLibraryDamageRequestImageSignedPutUrl?.map(
              async (signedData, index) => {
                try {
                  await fileUpload(
                    signedData?.signedUrl,
                    values?.damageToyImage?.[index]?.originFileObj,
                  );
                  return {
                    key: signedData?.fileName,
                  };
                } catch (error) {
                  throw new Error(
                    `${values?.damageToyImage?.[index]?.name} upload failed. Please try again.`,
                  );
                }
              },
            ),
          );

          damageToyFileName = response;
        } catch (error) {
          setIsReportDamageLoading(false);
          openNotification('error', error.message);
        }
      }
      setDamageToyImage([]);
    }
    try {
      const response = await createRequestLibrary({
        variables: {
          data: {
            images: damageToyFileName || undefined,
            videoKey: video,
            libraryDamageRequest: {
              returnOrderItemId: order?.id,
              includedContents: values?.includedContentMasters,
              ...(values?.requiredContents
                ? {
                    requiredContents: values.requiredContents,
                    checklist: values.checklist,
                  }
                : {}),
            },
            description: values?.description,
            type: REQUEST_TYPES?.LIBRARY_DAMAGE,
          },
        },
      });
      if (response?.data) {
        setIsOrderLoading(true);
        setIsReportDamageModalOpen(false);
        reportDamageForm?.resetFields();
        setOrderList([]);
        setToyVideo([]);
        setDamageToyImage([]);
        setToyPreviewVideo();
        setToyPreviewVideo();
        returnOrders({
          variables: {
            filter: {
              ...initialOrderFilter,
              skip:
                (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
              limit: paginationProp?.pageSize || LIMIT,
              search: orderSearchTerm,
              deliveryType: finalWhereFilters?.deliveryType,
              dateRange: {
                from: finalWhereFilters?.createdAt?.from?.$d,
                to: finalWhereFilters?.createdAt?.to?.$d,
              },
              status:
                finalWhereFilters?.status?.length > 0
                  ? finalWhereFilters?.status
                  : initialOrderFilter?.status,
              returnedOn: {
                from: finalWhereFilters?.returnedOn?.from?.$d,
                to: finalWhereFilters?.returnedOn?.to?.$d,
              },
              returnOrderIds: finalWhereFilters?.returnOrderNumber,
              pincodeIds: finalWhereFilters?.pincodes,
              ownerLibraryIds:
                finalWhereFilters?.ownerLibraryName?.length > 0
                  ? finalWhereFilters?.ownerLibraryName
                  : undefined,
              receivingLibraryIds:
                finalWhereFilters?.receivingLibraryName?.length > 0
                  ? finalWhereFilters?.receivingLibraryName
                  : undefined,
              orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
            },
            sort: sortedInfo?.column
              ? {
                field: sortedInfo?.field,
                order:
                  sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
              : initialOrderSort,
          },
        });
      }
    } catch (error) {
      return error;
    }
    setIsReportDamageLoading(false);
  };

  const handleReturnOrder = async () => {
    setIsReturnOrderLoading(true);
    const response = await updateOrderStatus({
      variables: {
        where: { id: order?.returnOrder?.id },
        data: {
          status: RETURN_ORDER_ITEM_STATUS.RETURNED.value,
        },
      },
    });

    if (response?.data) {
      setOrderList([]);
      setIsOrderLoading(true);
      setIsReturnPrompts(false);
      returnOrders({
        variables: {
          filter: {
            ...initialOrderFilter,
            skip:
              (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
            limit: paginationProp?.pageSize || LIMIT,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : initialOrderFilter?.status,
            returnedOn: {
              from: finalWhereFilters?.returnedOn?.from?.$d,
              to: finalWhereFilters?.returnedOn?.to?.$d,
            },
            returnOrderIds: finalWhereFilters?.returnOrderNumber,
            pincodeIds: finalWhereFilters?.pincodes,
            ownerLibraryIds:
              finalWhereFilters?.ownerLibraryName?.length > 0
                ? finalWhereFilters?.ownerLibraryName
                : undefined,
            receivingLibraryIds:
              finalWhereFilters?.receivingLibraryName?.length > 0
                ? finalWhereFilters?.receivingLibraryName
                : undefined,
            orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
          },
          sort: sortedInfo?.column
            ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
            : initialOrderSort,
        },
      });
    }
    setIsReturnOrderLoading(false);
  };

  const handleConfirmReturn = async () => {
    setIsConfirmReturnLoading(true);
    setOrderList([]);
    const response = await confirmReturnOrder({
      variables: {
        where: { id: order?.returnOrder?.id },
      },
    });
    if (response?.data) {
      setOrderList([]);
      setIsOrderLoading(true);
      setIsConfirmReturnPrompts(false);
      returnOrders({
        variables: {
          filter: {
            ...initialOrderFilter,
            skip:
              (paginationProp?.current - 1) * (paginationProp?.pageSize || 0),
            limit: paginationProp?.pageSize || LIMIT,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : initialOrderFilter?.status,
            returnedOn: {
              from: finalWhereFilters?.returnedOn?.from?.$d,
              to: finalWhereFilters?.returnedOn?.to?.$d,
            },
            returnOrderIds: finalWhereFilters?.returnOrderNumber,
            pincodeIds: finalWhereFilters?.pincodes,
            ownerLibraryIds:
              finalWhereFilters?.ownerLibraryName?.length > 0
                ? finalWhereFilters?.ownerLibraryName
                : undefined,
            receivingLibraryIds:
              finalWhereFilters?.receivingLibraryName?.length > 0
                ? finalWhereFilters?.receivingLibraryName
                : undefined,
            orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
          },
          sort: sortedInfo?.column
            ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
            : initialOrderSort,
        },
      });
    }
    setIsConfirmReturnLoading(false);
  };

  const handleFilter = (values) => {
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    setIsOrderLoading(true);
    setIsAllFilterModalOpen(false);
    setOrderList([]);
    setIsActive(true);
    const filters = {
      status: values?.status,
      createdAt: values?.createdAt?.[1]
        ? { from: values?.createdAt?.[0], to: values?.createdAt?.[1] }
        : null,
      returnedOn: values?.returnedOn?.[1]
        ? { from: values?.returnedOn?.[0], to: values?.returnedOn?.[1] }
        : null,
      pincodes: values?.pincodes,
      deliveryType: values?.deliveryType,
      ownerLibraryName: values?.ownerLibraryName,
      receivingLibraryName: values?.receivingLibraryName,
    };
    setWhereFilter(filters);
    setFinalWhereFilters(filters);
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: orderSearchTerm,
          deliveryType: values?.deliveryType,
          dateRange: {
            from: values?.createdAt?.[0],
            to: values?.createdAt?.[1],
          },
          returnedOn: {
            from: values?.returnedOn?.[0],
            to: values?.returnedOn?.[1],
          },
          status: values?.status?.length > 0 ? values?.status : initialOrderFilter?.status,
          pincodeIds: values?.pincodes,
          ownerLibraryIds:
            values?.ownerLibraryName?.length > 0
              ? values?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            values?.receivingLibraryName?.length > 0
              ? values?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sortedInfo?.column
          ? {
            field: sortedInfo?.field,
            order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
  };

  const handleTagFilterChange = (tagIds) => {
    selectedTagIdsRef.current = tagIds;
    setSelectedTagIds(tagIds);
    setIsOrderLoading(true);
    setOrderList([]);
    setIsActive(true);
    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          limit: paginationProp?.pageSize || LIMIT,
          search: orderSearchTerm,
          deliveryType: finalWhereFilters?.deliveryType,
          dateRange: {
            from: finalWhereFilters?.createdAt?.from?.$d,
            to: finalWhereFilters?.createdAt?.to?.$d,
          },
          returnedOn: {
            from: finalWhereFilters?.returnedOn?.from?.$d,
            to: finalWhereFilters?.returnedOn?.to?.$d,
          },
          status: finalWhereFilters?.status?.length > 0 ? finalWhereFilters?.status : initialOrderFilter?.status,
          returnOrderIds: finalWhereFilters?.returnOrderNumber,
          pincodeIds: finalWhereFilters?.pincodes,
          ownerLibraryIds: finalWhereFilters?.ownerLibraryName?.length > 0 ? finalWhereFilters?.ownerLibraryName : undefined,
          receivingLibraryIds: finalWhereFilters?.receivingLibraryName?.length > 0 ? finalWhereFilters?.receivingLibraryName : undefined,
          orderTagIds: tagIds?.length > 0 ? tagIds : undefined,
        },
        sort: sortedInfo?.column
          ? { field: sortedInfo?.field, order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC }
          : initialOrderSort,
      },
    });
  };

  const handleOrderScroll = () => {
    if (!isFetchMoreOrderLoading && !isOrderLoading) {
      const currentLength = orderList?.length;
      setIsFetchMoreOrderLoading(true);
      returnOrders({
        variables: {
          filter: {
            ...initialOrderFilter,
            skip: currentLength,
            limit: paginationProp?.pageSize || LIMIT,
            search: orderSearchTerm,
            deliveryType: finalWhereFilters?.deliveryType,
            dateRange: {
              from: finalWhereFilters?.createdAt?.from?.$d,
              to: finalWhereFilters?.createdAt?.to?.$d,
            },
            returnedOn: {
              from: finalWhereFilters?.returnedOn?.from?.$d,
              to: finalWhereFilters?.returnedOn?.to?.$d,
            },
            status:
              finalWhereFilters?.status?.length > 0
                ? finalWhereFilters?.status
                : initialOrderFilter?.status,
            returnOrderIds: finalWhereFilters?.returnOrderNumber,
            pincodeIds: finalWhereFilters?.pincodes,
            ownerLibraryIds:
              finalWhereFilters?.ownerLibraryName?.length > 0
                ? finalWhereFilters?.ownerLibraryName
                : undefined,
            receivingLibraryIds:
              finalWhereFilters?.receivingLibraryName?.length > 0
                ? finalWhereFilters?.receivingLibraryName
                : undefined,
            orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
          },
          sort: sortedInfo?.column
            ? {
              field: sortedInfo?.field,
              order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
            }
            : initialOrderSort,
        },
      });
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks, no-use-before-define
  const infiniteScrollRef = useInfiniteScroll(handleOrderScroll, isActive);
    const [assignDeliveryPartner] = useMutation(
    ASSIGN_DELIVERY_PARTNER_TO_RETURN_ORDER,
    {
      onError: () => {},
    },
  );
    const handleAssignDeliveryPartner = async (rowKeys, deliveryPartner) => {
    setIsDeliveryPartnerLoading(true);
    const response = await assignDeliveryPartner({
      variables: {
        where: {
          returnOrderIds: rowKeys,
        },
        data: {
          deliveryPartnerId: deliveryPartner,
        },
      },
    });
    if (response?.data) {
      setIsOrderLoading(true);
      setDeliveryPartnerModalOpen(false);
      setOrderList([]);
      setSelectedRowKeys([]);
      setSelectedRowKeys([]);
      setIsDeliveryPartnerPrompts(false);
      setDeliveryPartnerData({});
      assignDelPartnerForm.resetFields();
      returnOrders({
        variables: {
          filter: {
            ...initialOrderFilter,
            search: orderSearchTerm,
            deliveryType: whereFilter?.deliveryType,
            status:
              whereFilter?.status?.length > 0
                ? whereFilter?.status
                : initialOrderFilter?.status,
            pincodeIds: whereFilter?.pincodes,
            deliveryPartnerIds: whereFilter?.deliveryPartnerName,
            returnOrderIds: whereFilter?.returnOrderNumber,
            toyIds: whereFilter?.productName,
            libraryIds: whereFilter?.name,
            receivingLibraryIds: whereFilter?.receivingLibName,
            orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
          },
          sort: sortedInfo?.column
            ? {
                field: sortedInfo?.field,
                order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
              }
            : initialOrderSort,
        },
      });
    }
    setIsDeliveryPartnerLoading(false);
  };

  const getFilterData = (confirm) => {
    setIsOrderLoading(true);
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: orderSearchTerm,
          deliveryType: whereFilter?.deliveryType,
          dateRange: {
            from: whereFilter?.createdAt?.from?.$d,
            to: whereFilter?.createdAt?.to?.$d,
          },
          status:
            whereFilter?.status?.length > 0 ? whereFilter?.status : initialOrderFilter?.status,
          returnedOn: {
            from: whereFilter?.returnedOn?.from?.$d,
            to: whereFilter?.returnedOn?.to?.$d,
          },
          returnOrderIds: whereFilter?.returnOrderNumber,
          pincodeIds: whereFilter?.pincodes,
          ownerLibraryIds:
            whereFilter?.ownerLibraryName?.length > 0
              ? whereFilter?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            whereFilter?.receivingLibraryName?.length > 0
              ? whereFilter?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sortedInfo?.column
          ? {
            field: sortedInfo?.field,
            order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFilter });
    setExportFilter({ ...exportFilter, ...finalWhereFilters, ...whereFilter });
    setFinalFilterTags(filterTags);
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    if (confirm) {
      confirm();
    }
  };

  const handleReset = (clearFilters, dataIndex, confirm) => {
    const tagsCopy = {
      ...filterTags,
      [dataIndex]: [],
    };
    let whereFiltersCopy;
    if (dataIndex === 'deliveryType') {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: null,
      };
    } else {
      whereFiltersCopy = {
        ...whereFilter,
        [dataIndex]: [],
      };
    }
    setFilterVisible(false);
    setFinalFilterTags({ ...filterTags, ...tagsCopy });
    setFinalWhereFilters({ ...finalWhereFilters, ...whereFiltersCopy });
    setExportFilter({
      ...exportFilter,
      ...finalWhereFilters,
      ...whereFiltersCopy,
    });
    setIsOrderLoading(true);
    returnOrders({
      variables: {
        filter: {
          ...initialOrderFilter,
          search: orderSearchTerm,
          limit: paginationProp?.pageSize || LIMIT,
          dateRange: {
            from: whereFiltersCopy?.createdAt?.from?.$d,
            to: whereFiltersCopy?.createdAt?.to?.$d,
          },
          deliveryType: whereFiltersCopy?.deliveryType,
          status:
            whereFiltersCopy?.status?.length > 0
              ? whereFiltersCopy?.status
              : initialOrderFilter?.status,
          returnedOn: {
            from: whereFiltersCopy?.returnedOn?.from?.$d,
            to: whereFiltersCopy?.returnedOn?.to?.$d,
          },
          returnOrderIds: whereFiltersCopy?.returnOrderNumber,
          pincodeIds: whereFiltersCopy?.pincodes,
          ownerLibraryIds:
            whereFiltersCopy?.ownerLibraryName?.length > 0
              ? whereFiltersCopy?.ownerLibraryName
              : undefined,
          receivingLibraryIds:
            whereFiltersCopy?.receivingLibraryName?.length > 0
              ? whereFiltersCopy?.receivingLibraryName
              : undefined,
          orderTagIds: selectedTagIdsRef?.current?.length > 0 ? selectedTagIdsRef.current : undefined,
        },
        sort: sortedInfo?.column
          ? {
            field: sortedInfo?.field,
            order: sortedInfo?.order === 'ascend' ? SORT?.ASC : SORT?.DESC,
          }
          : initialOrderSort,
      },
    });
    setPaginationProp({ ...paginationProp, skip: 0, current: 1 });
    clearFilters();
    setFilterVisible(false);
    if (confirm) {
      confirm();
    }
  };

  useEffect(() => {
    if (filterVisible) {
      setFilterList([]);
      setFilterLoading(true);
      setIsEmptyFilterList(false);
      setFilterTags({ ...filterTags, ...finalFilterTags });
      setWhereFilter({ ...whereFilter, ...finalWhereFilters });
      setFilterIsEnd(false);
      const optionsCopy = [];

      switch (filterIndex) {
        case 'returnOrderNumber':
          returnOrdersSelect({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        case 'pincodes':
          pincodes({
            variables: {
              filter: {
                ...initialTableFilter,
              },
              sort: {
                field: 'pincode',
                order: 'ASC',
              },
            },
          });
          break;

        case 'ownerLibraryName':
        case 'senderLibraryName':
        case 'receivingLibraryName':
          libraries({
            variables: {
              filter: initialTableFilter,
              sort: initialTableSort,
            },
          });
          break;

        case 'deliveryType':
          forEach(DELIVERY_TYPE_OPTIONS, (item) => {
            optionsCopy?.push({ label: item?.label, key: item?.value });
          });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        case 'status':
          Object.values(RETURN_ORDER_ITEM_STATUS)
            ?.filter((item) => RETURN_RIDER_REASSIGNABLE_STATUSES?.includes(item?.value))
            ?.forEach((item) => {
              optionsCopy?.push({ label: item?.label, key: item?.value });
            });
          setFilterList(optionsCopy);
          setFilterLoading(false);
          break;

        default:
          break;
      }
    }
    if (!filterVisible) {
      setFilterTags(finalFilterTags);
      setWhereFilter(finalWhereFilters);
      setFilterSearch('');
    }
  }, [filterVisible]);

  const onFilterScroll = (event, dataIndex) => {
    if (filterScrollDebounceJob) {
      filterScrollDebounceJob?.cancel();
      filterScrollDebounceJob = null;
    }
    if (!isPincodesLoading && !isReturnOrdersSelectLoading && !filterIsEnd) {
      const target = event?.target;
      const currentLength = filterList?.length;
      if (
        target?.scrollTop + target?.offsetHeight >=
        target?.scrollHeight - 5
      ) {
        filterScrollDebounceJob = debounce(() => {
          setFilterLoading(true);
          switch (dataIndex) {
            case 'returnOrderNumber':
              returnOrdersSelect({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            case 'pincodes':
              pincodes({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: {
                    field: 'pincode',
                    order: 'ASC',
                  },
                },
              });
              break;

            case 'ownerLibraryName':
            case 'senderLibraryName':
            case 'receivingLibraryName':
              libraries({
                variables: {
                  filter: {
                    limit: LIMIT,
                    skip: currentLength,
                    search: filterSearch,
                  },
                  sort: initialTableSort,
                },
              });
              break;

            default:
              break;
          }
        }, 500);
        filterScrollDebounceJob();
      }
    }
  };

  const handleFilterSearch = (value, dataIndex) => {
    setFilterSearch(value);
    setFilterIsEnd(false);
    setFilterLoading(true);
    setFilterList([]);
    switch (dataIndex) {
      case 'returnOrderNumber':
        returnOrdersSelect({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      case 'pincodes':
        pincodes({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: {
              field: 'pincode',
              order: 'ASC',
            },
          },
        });
        break;

      case 'ownerLibraryName':
      case 'senderLibraryName':
      case 'receivingLibraryName':
        libraries({
          variables: {
            filter: {
              ...initialTableFilter,
              limit: LIMIT,
              search: value,
            },
            sort: initialTableSort,
          },
        });
        break;

      default:
        break;
    }
  };

  const changeFilter = (newFilterObj, dataIndex) => {
    const {
      target: { value },
    } = newFilterObj;

    const filterTagsCopy = { ...filterTags };
    let newTagList;
    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filter(filterTagsCopy?.[dataIndex], (item) => {
          if (item?.label) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    } else {
      newTagList = {
        ...filterTagsCopy,
        [dataIndex]: filterTagsCopy?.[dataIndex]
          ? [...filterTagsCopy?.[dataIndex], value]
          : [value],
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
  };

  const handleDeleteFilter = (value, dataIndex) => {
    let newTagList;

    if (whereFilter?.[dataIndex]?.includes(value?.key)) {
      newTagList = {
        ...filterTags,
        [dataIndex]: filter(filterTags?.[dataIndex], (item) => {
          if (item?.key) {
            return item?.key !== value?.key;
          }
          return item !== value;
        }),
      };
    }

    const updatedWhereFilter = {
      ...whereFilter,
      [dataIndex]: newTagList?.[dataIndex]?.map((item) => item?.key),
    };
    setWhereFilter(updatedWhereFilter);
    setFilterTags(newTagList);
  };

  const onRangePickerChange = (values, dataIndex) => {
    const rangeObj = {
      from: values[0]?.startOf('day'),
      to: values?.[1]?.endOf('day'),
    };

    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: rangeObj,
    };
    if (!values?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const handleOrderItemChange = (value, record) => {
    setOrderItem(record);
    setDeliveryPartnerData(value);
    setIsDeliveryPartnerPrompts(true);
  };

  const onRadioChange = (value, dataIndex) => {
    const filtersCopy = {
      ...whereFilter,
      [dataIndex]: value,
    };
    if (!value?.length) {
      delete whereFilter?.[dataIndex];
    }
    setWhereFilter(filtersCopy);
  };

  const filterPopup = (dataIndex, showSearch = true) => ({
    filterDropdown: ({ confirm, clearFilters }) => {
      if (dataIndex === 'createdAt' || dataIndex === 'returnedOn') {
        return (
          <div className="custom-filter-dropdown">
            <RangePicker
              allowClear={false}
              format={DATE_FORMATS?.REGULAR}
              onChange={(values) => onRangePickerChange(values, dataIndex)}
              value={
                whereFilter?.[dataIndex]?.from
                  ? [
                    whereFilter?.[dataIndex]?.from,
                    whereFilter?.[dataIndex]?.to,
                  ]
                  : null
              }
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      if (dataIndex === 'deliveryType') {
        return (
          <div className="custom-filter-dropdown">
            <Group
              options={DELIVERY_TYPE_OPTIONS}
              value={whereFilter?.[dataIndex]}
              onChange={(e) => onRadioChange(e?.target?.value, dataIndex)}
            />
            <Divider className="divider-filter" />
            <div className="d-flex justify-center">
              <Button
                size="small"
                className="reset-button"
                id="roles-filter-reset"
                onClick={() => handleReset(clearFilters, dataIndex, confirm)}
              >
                Reset
              </Button>
              <Button
                size="small"
                className="common-button ok-button"
                id="roles-filter-ok"
                type="primary"
                onClick={() => getFilterData(confirm, dataIndex)}
              >
                Ok
              </Button>
            </div>
          </div>
        );
      }

      return (
        <div className="custom-filter-dropdown">
          <LoaderComponent
            spinning={filterLoading}
            setHeight={35}
            size="medium"
          >
            {showSearch && (
              <SearchComponent
                className="filter-search"
                id="search-container-id-roles"
                placeholder="Search..."
                name={dataIndex}
                query={filterSearch}
                setQuery={setFilterSearch}
                getData={(value) => handleFilterSearch(value, dataIndex)}
              />
            )}
            {filterTags?.[dataIndex]?.length > 0 && (
              <div className="filter-tags-wrapper">
                {map(filterTags?.[dataIndex], (item) => (
                  <Tag
                    key={item?.key}
                    closable
                    onClose={() => handleDeleteFilter(item, dataIndex)}
                    className="filter-tag"
                  >
                    <span>{item?.label}</span>
                  </Tag>
                ))}
              </div>
            )}
            <div
              className="filter-checkboxes"
              onScroll={(e) => onFilterScroll(e, dataIndex)}
            >
              {filterList?.length > 0
                ? map(filterList, (item) => (
                  <div className="single-checkbox-div" key={item?.key}>
                    <Checkbox
                      value={item}
                      checked={whereFilter?.[dataIndex]?.includes(item?.key)}
                      key={item?.key || item}
                      onChange={(e) => changeFilter(e, dataIndex)}
                      className="single-checkbox"
                    >
                      <span>{item?.label}</span>
                    </Checkbox>
                  </div>
                ))
                : isEmptyFilterList && (
                  <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
                )}
            </div>
          </LoaderComponent>
          <Divider className="divider-filter" />
          <div className="d-flex justify-center">
            <Button
              size="small"
              className="reset-button"
              id="roles-filter-reset"
              onClick={() => handleReset(clearFilters, dataIndex, confirm)}
            >
              Reset
            </Button>
            <Button
              size="small"
              className="common-button ok-button"
              id="roles-filter-ok"
              type="primary"
              onClick={() => getFilterData(confirm, dataIndex)}
            >
              Ok
            </Button>
          </div>
        </div>
      );
    },
    filterIcon: () =>
      finalWhereFilters?.[dataIndex]?.length > 0 ||
        !isEmpty(finalWhereFilters?.[dataIndex]) ||
        finalWhereFilters?.[dataIndex] === DELIVERY_TYPE?.PAID?.value ||
        finalWhereFilters?.[dataIndex] === DELIVERY_TYPE?.FREE?.value ? (
        <FilterFilled className="filter-icon filter-filled" />
      ) : (
        <FilterOutlined className="filter-icon" />
      ),
    onFilterDropdownOpenChange: (isVisible) => {
      setFilterIndex(dataIndex);
      setFilterVisible(isVisible);
    },
  });

  const handleChange = (value, record) => {
    setOrder(record);
    if (value === RETURN_ORDER_ITEM_STATUS?.RETURN_CONFIRMED?.value) {
      setIsConfirmReturnPrompts(true);
    } else {
      setIsReportDamageModalOpen(true);
    }
  };

  const renderBlinkingDotEl = (orderStatus) => {
    if (orderStatus === RETURN_ORDER_ITEM_STATUS?.RETURN_REQUESTED?.value) {
      return (
        <Badge status="processing" color="red" className="custom-badge mr-8" />
      );
    }

    return null;
  };
  const hasSelected = selectedRowKeys.length > 0;
  const columns = [
    {
      title: 'PRODUCT RETURN ID',
      fixed: 'left',
      dataIndex: 'returnOrderNumber',
      key: 'returnOrderNumber',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 150,
      render: (_, record) => (
        <div className="d-flex align-center">
          {renderBlinkingDotEl(record?.status)}
          <RenderCopyIcon copyText={record?.returnOrder?.returnOrderNumber} toolTipText='Copy Return ID' />
          {record?.returnOrder?.returnOrderNumber}
          {hasLargeToy(record) && <BigToyIcon />}
          <OrderDynamicTags tags={record?.returnOrder?.orderTags} />
        </div>
      ),
    },
    {
      title: 'PRODUCT NAME',
      fixed: 'left',
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
      align: 'left',
      width: 250,
      className: 'max-width-column',
      render: (_, record) => {
        const toyData = record?.orderItem?.toy;
        return (
          <>
            <div className="table-data-with-id">{toyData?.name || '-'}</div>
            {toyData?.toyNumber && (
              <div className="font-size-12">({toyData?.toyNumber})</div>
            )}
          </>
        );
      },
    },
      {
      title: 'MAPPED UNIT',
      hidden: !isUnitsFeatureEnabled,
      dataIndex: 'inventoryUnits',
      key: 'inventoryUnits',
      width: 200,
      align: 'left',
      className: 'max-width-column',
      onCell: () => ({
        onClick: (e) => e?.stopPropagation(),
      }),
      render: (_, record) => <MappedUnitsCell units={record?.inventoryUnits} />,
    },
    {
      title: 'ORDER ID',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      width: 150,
      render: (_, record) =>  <div className="d-flex align-center">
          <RenderCopyIcon copyText={record?.order?.orderNumber} />
          {record?.order?.orderNumber || '-'}
          <OrderDynamicTags tags={record?.orderTags} />
        </div>,
    },
    {
      title: 'DELIVERY TYPE',
      dataIndex: 'deliveryType',
      key: 'deliveryType',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) =>
        DELIVERY_TYPE?.[record?.order?.deliveryType]?.label,
      ...filterPopup('deliveryType'),
    },
    {
      title: 'USER ID',
      dataIndex: 'userId',
      key: 'userId',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) => record?.returnOrder?.user?.userNumber || '-',
    },
    {
      title: 'OWNER LIBRARY NAME',
      dataIndex: 'ownerLibraryName',
      key: 'ownerLibraryName',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      render: (_, record) => {
        const ownerLib = record?.libraryInventory?.library;
        return ownerLib ? (
          <>
            <div className="table-data-with-id">{ownerLib?.name}</div>
            <div className="font-size-12">({ownerLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
      ...filterPopup('ownerLibraryName'),
    },
    {
      title: 'SENDER LIBRARY NAME',
      dataIndex: 'senderLibraryName',
      key: 'senderLibraryName',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      render: (_, record) => {
        const ownerLib = record?.returnOrder?.library;
        return ownerLib ? (
          <>
            <div className="table-data-with-id">{ownerLib?.name}</div>
            <div className="font-size-12">({ownerLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
    },
    {
      title: 'RECEIVER LIBRARY NAME',
      dataIndex: 'receivingLibraryName',
      key: 'receivingLibraryName',
      align: 'left',
      ellipsis: true,
      className: `max-width-column`,
      width: 300,
      render: (_, record) => {
        const receivingLib = record?.returnOrder?.receiverLibrary;
        return receivingLib ? (
          <>
            <div className="table-data-with-id">{receivingLib?.name}</div>
            <div className="font-size-12">({receivingLib?.libraryNumber})</div>
          </>
        ) : (
          '-'
        );
      },
      ...filterPopup('receivingLibraryName'),
    },
    {
      title: 'DELIVERY PARTNER NAME',
      dataIndex: 'deliveryPartnerName',
      key: 'deliveryPartnerName',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) => (
        <>
          {record?.returnOrder?.deliveryPartner?.firstName ||
            record?.returnOrder?.deliveryPartner?.lastName ? (
            <div className="table-data-with-id">{`${record?.returnOrder?.deliveryPartner?.firstName
              ? record?.returnOrder?.deliveryPartner?.firstName
              : ''
              } ${record?.returnOrder?.deliveryPartner?.lastName
                ? record?.returnOrder?.deliveryPartner?.lastName
                : ''
              }`}</div>
          ) : (
            '-'
          )}
          {record?.returnOrder?.deliveryPartner?.userNumber ? (
            <div className="font-size-12">
              ({record?.returnOrder?.deliveryPartner?.userNumber})
            </div>
          ) : (
            ''
          )}
        </>
      ),
    },
    {
      title: 'PINCODE',
      dataIndex: 'pincode',
      key: 'pincode',
      ellipsis: true,
      align: 'left',
      width: 150,
      className: 'max-width-column',
      render: (_, record) => record?.returnOrder?.pincode?.pincode || '-',
      ...filterPopup('pincodes'),
    },
    {
      title: 'PLACED ON',
      dataIndex: 'placedOn',
      key: 'placedOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.createdAt, DATE_FORMATS?.WITH_TIME),
      ...filterPopup('createdAt'),
    },
    {
      title: 'RETURNED ON',
      dataIndex: 'deliveredOn',
      key: 'deliveredOn',
      ellipsis: true,
      align: 'left',
      width: 200,
      className: 'max-width-column',
      render: (_, record) =>
        formatDate(record?.returnedOn, DATE_FORMATS?.REGULAR) || '-',
      ...filterPopup('returnedOn'),
    },
    {
      title: 'PICKED UP ATTACHMENT',
      dataIndex: 'pickedUpAttachments',
      key: 'pickedUpAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const pickedUpAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            [RETURN_ORDER_ITEM_STATUS?.PICKED_UP?.value, null]?.includes(
              attachment?.deliveryAttachmentsType,
            ),
        );

        const hasAttachments = pickedUpAttachments?.length > 0;
        const additionalCount = pickedUpAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(pickedUpAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(pickedUpAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },
    {
      title: 'RETURNED ATTACHMENTS',
      dataIndex: 'returnedAttachments',
      key: 'returnedAttachments',
      ellipsis: true,
      width: 200,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => {
        const returnedAttachments = record?.deliveryAttachments?.filter(
          (attachment) =>
            attachment?.deliveryAttachmentsType ===
            RETURN_ORDER_ITEM_STATUS?.RETURNED?.value,
        );

        const hasAttachments = returnedAttachments?.length > 0;
        const additionalCount = returnedAttachments?.length - 1;

        return (
          <span>
            {hasAttachments ? (
              <Image
                preview={{ visible: false }}
                width={20}
                height={20}
                src={getAttachmentSource(returnedAttachments?.[0])}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(returnedAttachments);
                }}
                className="pointer"
              />
            ) : (
              <span>No Images</span>
            )}
            {additionalCount > 0 && ` + ${additionalCount}`}
          </span>
        );
      },
    },
    {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => RETURN_ORDER_ITEM_STATUS?.[record?.status]?.label,
      ...filterPopup('status', false),
    },
    {
      title: 'NOTE',
      dataIndex: 'note',
      key: 'note',
      ellipsis: true,
      width: 150,
      align: 'left',
      className: 'max-width-column',
      render: (_, record) => (
        <div className="action-button" onClick={(e) => e?.stopPropagation()}>
          {record?.status === RETURN_ORDER_ITEM_STATUS?.NOT_PICKED_UP?.value &&
          (record?.returnOrder?.metadata?.notPickedUpReason) ? (
            <Tooltip title="View reason" placement="top" zIndex={4}>
              <CommentIcon
                className="mr-16 pointer svg-icon"
                onClick={() => {
                  const partnerData =
                    record?.returnOrder?.deliveryPartner ||
                    record?.returnOrder?.metadata?.deliveryStaffDetails ||
                    record?.order?.metadata?.deliveryStaffDetails;
                  const riderName = partnerData
                    ? `${partnerData?.firstName || partnerData?.name || ''} ${
                        partnerData?.lastName || ''
                      }`.trim()
                    : '';
                  setNotPickedUpReason(
                    record?.returnOrder?.metadata?.notPickedUpReason,
                  );
                  setNotPickedUpRiderName(riderName);
                  setIsNotPickedUpReasonModalOpen(true);
                }}
              />
            </Tooltip>
          ) : (
            <span className="mr-24">-</span>
          )}
        </div>
      ),
    },
    {
      title: 'SKIP CHECKLIST',
      hidden: !isUnitsFeatureEnabled,
      dataIndex: 'skipChecklist',
      key: 'skipChecklist',
      width: 150,
      align: 'left',
      onCell: () => ({
        onClick: (e) => e?.stopPropagation(),
      }),
      render: (_, record) => (
        <SkipChecklistAction
          returnOrderId={record?.returnOrder?.id}
          status={record?.status}
          value={getSkipChecklistValue(record?.returnOrder)}
        />
      ),
    },
    {
      title: 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      width: 250,
      render: (_, record) => {
        const deliveryPartner = record?.returnOrder?.deliveryPartner;
        const assignedDeliveryPartner = {
          firstName: deliveryPartner?.firstName,
          lastName: deliveryPartner?.lastName,
          id: deliveryPartner?.id,
          userNumber: deliveryPartner?.userNumber,
        };
        return (
          <div onClick={(e) => e?.stopPropagation()}>
            <UserSelect
              size="small"
              className="user-select"
              placeholder="Select Action"
              showAction={['click']}
              value={deliveryPartner?.id || null}
              userData={
                record?.returnOrder?.deliveryPartner?.id
                  ? assignedDeliveryPartner
                  : null
              }
              roles={USER_ROLES?.DELIVERY?.key}
              onChange={(value, userData) =>
                handleOrderItemChange(userData, record, record)
              }
              allowClear={false}
            />
          </div>
        );
      },
    },
]?.filter((item) => {
    if (
      !roles?.includes(USER_ROLES?.LIBRARIAN?.key) &&
      item?.dataIndex === 'actions'
    ) {
      return item?.hidden;
    }
    return !item?.hidden;
  });

  const expandedRowRender = (data) => {
    const nestedData = [
      {
        id: data?.id,
        productName: data?.orderItem?.toy?.name,
        ageGroups: data?.orderItem?.toy?.ageGroups,
        toyCondition: data?.toyCondition,
        images: data?.images,
        productRate: data?.productRate,
        videoUrl: data?.videoUrl,
        returnOrderNumber: data?.returnOrder?.returnOrderNumber,
        brand: data?.orderItem?.toy?.brand?.name,
        productImages: data?.orderItem?.toy?.images,
        packagingMaterial: data?.orderItem?.toy?.bag,
        libraryInventoryId: data?.libraryInventory?.id,
      },
    ];

    const nestedColumns = [
      {
        title: 'PRODUCT NAME',
        fixed: 'left',
        dataIndex: 'productName',
        key: 'productName',
        ellipsis: true,
        align: 'left',
        width: 250,
        className: 'max-width-column',
      },
      {
        title: 'IMAGES',
        dataIndex: 'productImages',
        key: 'productImages',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => {
          const images = record?.productImages;
          return (
            <span>
              {images?.length > 0 ? (
                <>
                  <Image
                    preview={{
                      visible: false,
                    }}
                    width={20}
                    height={20}
                    src={images?.[0]?.url}
                    onClick={(e) => {
                      e?.stopPropagation();
                      setVisible(true);
                      setToyImages(images);
                    }}
                    className="pointer"
                  />
                </>
              ) : (
                <span>No Images</span>
              )}
              {images?.length > 1 ? ` + ${images?.length - 1}` : ''}
            </span>
          );
        },
      },
      {
        title: 'BRAND',
        dataIndex: 'brand',
        key: 'brand',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) => record?.brand || '-',
      },
      {
        title: 'AGE GROUP',
        dataIndex: 'ageGroup',
        key: 'ageGroup',
        align: 'left',
        width: 300,
        className: 'max-width-column',
        render: (_, record) =>
          record?.ageGroups?.map((ageGroup) =>
            ageGroup?.minAge > 18 ? (
              <Tag key={ageGroup?.id}>
                {Math.floor(ageGroup?.minAge / 12)} -{' '}
                {Math.floor(ageGroup?.maxAge / 12)} Years
              </Tag>
            ) : (
              <Tag key={ageGroup?.id}>
                {ageGroup?.minAge} - {ageGroup?.maxAge} Months
              </Tag>
            ),
          ),
      },
      {
        title: 'PACKAGING MATERIAL',
        dataIndex: 'packagingMaterial',
        key: 'packagingMaterial',
        ellipsis: true,
        width: 250,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <>
            {record?.packagingMaterial ? (
              <div>
                <span className="mr-8">
                  {record?.packagingMaterial?.name} (
                  {record?.packagingMaterial?.size})
                </span>
                <Image
                  preview={false}
                  width={22}
                  src={record?.packagingMaterial?.image}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setPreviewVisible(true);
                    setToyPreviewImage(record?.packagingMaterial?.image);
                  }}
                  className="pointer"
                />
              </div>
            ) : (
              '-'
            )}
          </>
        ),
      },
      {
        title: 'RETURN TOY IMAGES',
        dataIndex: 'image',
        key: 'image',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <span>
            {record?.images?.length > 0 ? (
              <>
                <Image
                  preview={{
                    visible: false,
                  }}
                  width={20}
                  height={20}
                  src={record?.images?.[0]?.url}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setVisible(true);
                    setToyImages(record?.images);
                  }}
                  className="pointer"
                />
              </>
            ) : (
              <span>No Images</span>
            )}
            {record?.images?.length > 1
              ? ` + ${record?.images?.length - 1}`
              : ''}
          </span>
        ),
      },
      {
        title: 'VIDEO',
        dataIndex: 'video',
        key: 'video',
        ellipsis: true,
        width: 100,
        align: 'left',
        className: 'max-width-column',
        render: (_, record) => (
          <span>
            {record?.videoUrl ? (
              <Tooltip title="Play" placement="top" zIndex={4}>
                <PlayIcon
                  onClick={() => {
                    setOrderItem(record);
                    setIsVideoModalOpen(true);
                  }}
                  className="mr-16 pointer svg-icon"
                />
              </Tooltip>
            ) : (
              '-'
            )}
          </span>
        ),
      },
      {
        title: 'PRODUCT RATING',
        dataIndex: 'productRate',
        key: 'productRate',
        ellipsis: true,
        align: 'left',
        width: 250,
        className: 'max-width-column',
        render: (_, record) => (
          <div className="action-button">
            {record?.productRate === PRODUCT_RATE?.LIKE ? (
              <Tooltip title="Rated" placement="top">
                <LikeRatingIcon className="mr-16 svg-icon" />
              </Tooltip>
            ) : (
              <Tooltip title="Unrated" placement="top">
                <DislikeRatingIcon className="mr-16 svg-icon" />
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        title: 'ORDER FULFILMENT',
        dataIndex: 'orderFulfilment',
        key: 'orderFulfilment',
        align: 'left',
        width: 200,
        render: (_, record) => (
          <Button
            type="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedPossibilityItem(record);
              setPossibilityDrawerVisible(true);
            }}
          >
            View
          </Button>
        ),
      },
    ];

    return (
      <CommonTable
        columns={nestedColumns}
        data={nestedData || []}
        paginationConfig={false}
        rowKey={(record) => record?.id}
        className="nested-table"
      />
    );
  };

  const locale = {
    emptyText: isEmptyOrderList ? '' : <span />,
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: isAssignDelPartnerTab
        ? false
        : record?.status === ORDER_STATUS?.CANCELLED?.value ||
          record?.status === ORDER_STATUS?.CONFIRMED?.value,
    }),
  };

  const handleCancel = () => {
    setIsContentMasterModalOpen(false);
    setOrder({});
  };

  return (
    <>
    <AssignDeliveryPartnerModal
        form={assignDelPartnerForm}
        onFinish={(values) =>
          handleAssignDeliveryPartner(selectedRowKeys, values?.name)
        }
        loadings={isDeliveryPartnerLoading}
        isModalOpen={isDeliveryPartnerModalOpen}
        setIsModalOpen={setDeliveryPartnerModalOpen}
        title="Assign Delivery Partner"
      />
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isConfirmReturnPrompts}
        onCancel={() => setIsConfirmReturnPrompts(false)}
        footer={[
          <div key="modal-actions">
            <Button
              onClick={handleConfirmReturn}
              type="primary"
              loading={isConfirmReturnLoading}
            >
              Confirm Return
            </Button>
            <Button
              onClick={() => {
                setIsConfirmReturnPrompts(false);
                setIsReportDamageModalOpen(true);
              }}
              type="primary"
            >
              Report Damage
            </Button>
            <Button
              onClick={() => setIsConfirmReturnPrompts(false)}
              className="cancel-btn"
            >
              Cancel
            </Button>
          </div>,
        ]}
      >
        Are you sure you want to
        <strong> Confirm Return / Report Damage </strong>
        this order item?
      </Modal>
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isReturnPrompts}
        onCancel={() => setIsReturnPrompts(false)}
        footer={[
          <div key="modal-actions">
            <Button
              onClick={handleReturnOrder}
              type="primary"
              loading={isReturnOrderLoading}
            >
              Return Order
            </Button>

            <Button
              onClick={() => setIsReturnPrompts(false)}
              className="cancel-btn"
            >
              Cancel
            </Button>
          </div>,
        ]}
      >
        Are you sure you want to mark this order as
        <strong> Returned </strong>?
      </Modal>
      <Modal
        title="Caution"
        okText="Yes"
        cancelText="No"
        open={isDeliveryPartnerPrompts}
        onOk={() =>
          handleAssignDeliveryPartner(
            [orderItem?.returnOrder?.id],
            deliveryPartnerData?.key,
          )
        }
        onCancel={() => setIsDeliveryPartnerPrompts(false)}
        okButtonProps={{ loading: isDeliveryPartnerLoading }}
      >
        Are you sure you want to assign
        <strong> {deliveryPartnerData?.children} </strong>?
      </Modal>
      <ContentMasterModal
        isModalOpen={isContentMasterModalOpen}
        contentHistory={order?.contentHistory}
        handleCancel={handleCancel}
        isReturn
      />
      <ToyVideoModal
        title={`Video - ${orderItem?.returnOrderNumber}`}
        isModalOpen={isVideoModalOpen}
        setIsModalOpen={setIsVideoModalOpen}
        videoUrl={orderItem?.videoUrl}
      />
      <FulfilmentPossibilityDrawer
        visible={possibilityDrawerVisible}
        onClose={() => setPossibilityDrawerVisible(false)}
        libraryInventoryId={selectedPossibilityItem?.libraryInventoryId}
        returnOrderItemId={selectedPossibilityItem?.id}
        isReturnsOrderView
        isLibrary
        isDesktop={isDesktop}
      />
      <CommonPreviewTable
        visible={visible}
        setVisible={setVisible}
        images={toyImages}
        setImages={setToyImages}
      />
      <CommonPreview
        visible={previewVisible}
        setVisible={setPreviewVisible}
        image={toyPreviewImage}
        setImage={setToyPreviewImage}
      />
      <ReportDamageModal
        showInspectionForm={!isUnitsFeatureEnabled}
        isModalOpen={isReportDamageModalOpen}
        setIsModalOpen={setIsReportDamageModalOpen}
        isBtnLoading={isReportDamageLoading}
        onFinish={handleReportDamage}
        damageToyImage={damageToyImage}
        setDamageToyImage={setDamageToyImage}
        form={reportDamageForm}
        toyVideo={toyVideo}
        setToyVideo={setToyVideo}
        toyPreviewImage={toyPreviewImage}
        setToyPreviewImage={setToyPreviewImage}
        toyPreviewVideo={toyPreviewVideo}
        setToyPreviewVideo={setToyPreviewVideo}
        order={order}
        setOrder={setOrder}
      />
      <NoteModal
        note={order?.cancellationData}
        isModalOpen={isNotePrompts}
        setIsModalOpen={setIsNotePrompts}
      />
      <ModalComponent
        open={isNotPickedUpReasonModalOpen}
        onCancel={() => setIsNotPickedUpReasonModalOpen(false)}
        footer={null}
      >
        <div className="mb-8">
          <b className="font-size-16">
            Not Picked Up {notPickedUpRiderName ? `by ${notPickedUpRiderName}` : 'Reason'}
          </b>
        </div>
        <div className="font-size-16">
          Reason: {notPickedUpReason || '-'}
        </div>
      </ModalComponent>
      <div className="d-flex justify-end mb-16 align-center">
        <Button
          type="primary"
          disabled={!hasSelected}
          className="mr-8"
          onClick={() => setDeliveryPartnerModalOpen(true)}
        >
          Assign Rider
        </Button>
        <OrderTagsFilter
          value={selectedTagIds}
          onChange={handleTagFilterChange}
          placeholder="Filter by Tags"
          className="ml-8"
        />
        <SearchComponent
          className={isDesktop ? 'search-box ml-16' : ''}
          query={orderSearchTerm}
          setQuery={setOrderSearchTerm}
          getData={handleSearch}
        />
        {!isDesktop && (
          <Badge dot={hasNonEmptyValueObj(finalWhereFilters)} size="small">
            <FilterIcon
              className="mobile-svg-icon ml-16"
              onClick={() => setIsAllFilterModalOpen(true)}
            />
          </Badge>
        )}
      </div>
      {isDesktop ? (
        <CommonTable
          locale={locale}
          columns={columns}
          data={orderList || []}
          loading={isOrderLoading}
          rowSelection={rowSelection}
          onChange={handleTableChange}
          paginationConfig={paginationProp}
          rowKey={(record) => record?.id}
          onRow={() => ({
            style: { cursor: 'pointer' },
          })}
          expandable={{
            expandRowByClick: true,
            expandedRowRender: (record) => expandedRowRender(record),
          }}
        />
      ) : (
        <div className="mobile-container-tab no-scroll-bar">
          <AllFilterReturnOrderModal
            onFinish={handleFilter}
            isModalOpen={isAllFilterModalOpen}
            setIsModalOpen={setIsAllFilterModalOpen}
            finalWhereFilters={finalWhereFilters}
            setFinalWhereFilters={setFinalWhereFilters}
          />
          <AllReturnOrderItemModal
            order={order}
            setOrder={setOrder}
            isModalOpen={isAllReturnOrderItemModalOpen}
            setIsModalOpen={setIsAllReturnOrderItemModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
          />
          <AllReturnOrderList
            orderList={orderList}
            infiniteScrollRef={infiniteScrollRef}
            isFetchMoreOrderLoading={isFetchMoreOrderLoading}
            isEmptyOrderList={isEmptyOrderList}
            isOrderLoading={isOrderLoading}
            handleChange={handleChange}
            setOrder={setOrder}
            setIsContentMasterModalOpen={setIsContentMasterModalOpen}
            setIsAllReturnOrderItemModalOpen={setIsAllReturnOrderItemModalOpen}
            setVisible={setVisible}
            setToyImages={setToyImages}
            setIsReturnPrompts={setIsReturnPrompts}
          />
        </div>
      )}
    </>
  );
};

export default AllReturnTable;
